import { resourceExplorerProviderByProviderPossibleFiltersSelector } from "../resourceExplorerProviderByProviderPossibleFiltersSelector";
import { RootState } from "../../../../../store";

export const awsPossibleFiltersSelector = (state: RootState) => {
  return resourceExplorerProviderByProviderPossibleFiltersSelector({
    provider: "aws",
  })(state)?.data;
};
